/* 5S · BLOG UX (articles) — fichier PARTAGÉ, identique sur les 5 sites.
   Tout est fait à l'affichage : le HTML des articles n'est jamais modifié.
   Numéros = propositions validées par Pierre le 22/10/2026. */
(function () {
  'use strict';
  var root = document.querySelector('.ArticleContent');
  if (!root) return;
  var art = root.closest('.article-template') || document.body;
  var mqMobile = window.matchMedia('(max-width:768px)');

  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  /* (11)(26) hauteur du header collé → variables CSS */
  var hdr = document.querySelector('.section-header, sticky-header, header.header-wrapper');
  function setHdr() {
    if (!hdr) return;
    var r = hdr.getBoundingClientRect();
    document.documentElement.style.setProperty('--ux-hdr', Math.max(60, Math.round(r.height)) + 'px');
    document.documentElement.style.setProperty('--ux-top', Math.max(0, Math.round(r.bottom)) + 'px');
  }

  /* (9) date lisible + temps de lecture */
  (function () {
    var p = document.querySelector('.article-template .blog-updated');
    if (!p) return;
    var t = p.querySelector('time');
    var words = txt(root).split(' ').length;
    var min = Math.max(1, Math.round(words / 230));
    var d = t && t.getAttribute('datetime') ? new Date(t.getAttribute('datetime')) : null;
    var label = d && !isNaN(d) ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : (t ? txt(t) : '');
    p.innerHTML = '';
    var dot = document.createElement('span'); dot.className = 'dot5s'; dot.setAttribute('aria-hidden', 'true');
    p.appendChild(dot);
    p.appendChild(document.createTextNode('Updated '));
    if (t) { t.textContent = label; p.appendChild(t); }
    p.appendChild(document.createTextNode(' · ' + min + ' min read'));
  })();

  /* (17) « Our methodology » : encadré gris, toujours ouvert */
  [].forEach.call(root.querySelectorAll('.container-summary'), function (box) {
    var h = box.firstElementChild;
    if (h && h.tagName === 'H2' && /methodology/i.test(txt(h))) box.classList.add('meth5s');
  });

  /* (34) « Sources and methodology: » en gras */
  [].forEach.call(root.querySelectorAll('.sources-card'), function (c) {
    var n = c.firstChild;
    if (!n || n.nodeType !== 3) return;
    var m = n.nodeValue.match(/^(\s*Sources?(?:\s+and\s+methodology)?\s*:)/i);
    if (!m) return;
    var b = document.createElement('span'); b.className = 'sl5s'; b.textContent = m[1].trim();
    n.nodeValue = ' ' + n.nodeValue.slice(m[1].length).replace(/^\s+/, '');
    c.insertBefore(b, n);
  });

  /* (38) « Related blog posts » en cartes (on enlève les tirets tapés à la main) */
  [].forEach.call(art.querySelectorAll('.more-articles'), function (box) {
    box.classList.add('rl5s');
    [].forEach.call(box.querySelectorAll('p'), function (p) {
      if (!p.querySelector('a')) { p.classList.add('rh5s'); return; }
      var n = p.firstChild;
      if (n && n.nodeType === 3) n.nodeValue = n.nodeValue.replace(/^\s*[-–—•]\s*/, '');
    });
  });

  /* (12) bio des cartes expert/auteur coupée à 2 lignes + « Read more » */
  [].forEach.call(art.querySelectorAll('.author-card .author-bio'), function (bio) {
    bio.classList.add('cl5s');
    if (bio.scrollHeight <= bio.clientHeight + 2) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'rm5s'; b.textContent = 'Read more';
    b.addEventListener('click', function () {
      var c = bio.classList.toggle('cl5s');
      b.textContent = c ? 'Read more' : 'Show less';
    });
    bio.parentNode.insertBefore(b, bio.nextSibling);
  });

  /* ------------------------------ TABLEAUX ------------------------------ */
  var NUM = /^[~≈<>]?\s*(?:about|around|approx\.?|roughly|up to|from)?\s*[+\-−–]?\s*(?:US\$|R\$|S\/|[A-Z]{3}\$?|\$|€|£)?\s*[+\-−–]?\s*\d/i;
  var NUMS = /\d[\d,]*(?:\.\d+)?/g;
  function isEmpty(s) { return !s || /^[—–\-]$/.test(s) || /^n\/?a$/i.test(s); }

  function bodyRows(t) {
    var rows = [];
    if (t.tBodies.length) [].forEach.call(t.tBodies, function (b) { rows = rows.concat([].slice.call(b.rows)); });
    else rows = [].slice.call(t.rows);
    return rows.filter(function (r) { return ![].every.call(r.cells, function (c) { return c.tagName === 'TH'; }); });
  }
  function headRow(t) {
    if (t.tHead && t.tHead.rows.length) return t.tHead.rows[t.tHead.rows.length - 1];
    var r = t.rows[0];
    return r && [].every.call(r.cells, function (c) { return c.tagName === 'TH'; }) ? r : null;
  }

  function classify(t) {
    var rows = bodyRows(t);
    if (rows.length < 2) return;
    var span = [].some.call(t.querySelectorAll('td,th'), function (c) { return c.colSpan > 1; });
    if (span) return;
    var hr = headRow(t);
    var ncol = Math.max.apply(null, rows.map(function (r) { return r.cells.length; }));
    var numCols = [], txtCols = [];
    for (var c = 1; c < ncol; c++) {
      var cells = rows.map(function (r) { return r.cells[c]; }).filter(Boolean);
      var vals = cells.map(txt).filter(function (s) { return !isEmpty(s); });
      var hits = vals.filter(function (s) { return s.length <= 32 && NUM.test(s); }).length;
      if (vals.length >= 2 && hits / vals.length >= 0.7) numCols.push(c);
      else txtCols.push(c);
    }
    numCols.forEach(function (c) {
      rows.forEach(function (r) {
        var cell = r.cells[c]; if (!cell) return;
        cell.classList.add('n5s');
        if (txt(cell).length <= 18) cell.classList.add('nw5s');
      });
      if (hr && hr.cells[c]) hr.cells[c].classList.add('n5s');
    });
    /* (19) colonnes de commentaire en gris, seulement s'il y a aussi des chiffres */
    if (ncol >= 3 && numCols.length) {
      txtCols.forEach(function (c) {
        var cells = rows.map(function (r) { return r.cells[c]; }).filter(Boolean);
        var avg = cells.reduce(function (s, x) { return s + txt(x).length; }, 0) / (cells.length || 1);
        if (avg >= 12) cells.forEach(function (x) { x.classList.add('tx5s'); });
      });
    }
    /* (21) mini-barres : une seule colonne comparable (même unité, 1 nombre par cellule, 4 lignes ou plus) */
    if (rows.length >= 4) {
      var ok = numCols.filter(function (c) {
        var cells = rows.map(function (r) { return r.cells[c]; });
        if (cells.some(function (x) { return !x || isEmpty(txt(x)); })) return false;
        var sig = null, v = [], fine = true;
        cells.forEach(function (x) {
          var s = txt(x), m = s.match(NUMS);
          if (!m || m.length !== 1 || /\bto\b|–|—/.test(s)) { fine = false; return; }
          var g = s.replace(/[+\-−]/g, '').replace(NUMS, '#').replace(/\s+/g, ' ').trim();
          if (sig === null) sig = g; else if (g !== sig) fine = false;
          var n = parseFloat(m[0].replace(/,/g, ''));
          if (/[−\-]\s*\d/.test(s)) n = -n;
          v.push(n);
        });
        if (!fine) return false;
        var distinct = v.filter(function (x, i) { return v.indexOf(x) === i; }).length;
        if (distinct < 2) return false;
        if (sig === '#' && v.every(function (x) { return x >= 1900 && x <= 2100; })) return false;
        if (sig === '#' && v.every(function (x, i) { return x === i + 1; })) return false;
        var pos = v.every(function (x) { return x >= 0; }), neg = v.every(function (x) { return x <= 0; });
        if (!pos && !neg) return false;
        cells.forEach(function (x, i) { x._v5s = Math.abs(v[i]); });
        return true;
      });
      if (ok.length === 1) {
        var c0 = ok[0], cells0 = rows.map(function (r) { return r.cells[c0]; });
        var max = Math.max.apply(null, cells0.map(function (x) { return x._v5s; }));
        var bw = mqMobile.matches ? 64 : 110;
        if (max > 0) cells0.forEach(function (x) {
          var wpx = Math.max(3, Math.round(bw * x._v5s / max));
          x.innerHTML = '<span class="b5s"><i style="width:' + wpx + 'px" aria-hidden="true"></i><span>' + x.innerHTML + '</span></span>';
        });
      }
    }
    /* (26) en-tête collé : 8 lignes ou plus */
    if (rows.length >= 8 && (t.tHead || hr)) t.classList.add('lg5s');
  }

  var wraps = [];
  [].forEach.call(root.querySelectorAll('table'), function (t) {
    try { classify(t); } catch (e) {}
    if (t.closest('.main-table-wrap, .yield-table-wrap, .to5s')) return;
    var o = document.createElement('div'); o.className = 'to5s';
    var w = document.createElement('div'); w.className = 'tw5s';
    var hint = document.createElement('div'); hint.className = 'sw5s'; hint.textContent = 'Swipe →';
    t.parentNode.insertBefore(o, t); w.appendChild(t); o.appendChild(w); o.appendChild(hint);
    w.addEventListener('scroll', function () {
      if (w.scrollLeft > 10) o.classList.add('moved');
      o.classList.toggle('end', w.scrollLeft + w.clientWidth >= w.scrollWidth - 2);
    }, { passive: true });
    wraps.push([o, w]);
  });
  function checkWraps() {
    wraps.forEach(function (x) {
      var o = x[0], w = x[1];
      o.classList.remove('sc');
      var sc = w.scrollWidth > w.clientWidth + 2;
      o.classList.toggle('sc', sc);
      if (sc) o.classList.toggle('end', w.scrollLeft + w.clientWidth >= w.scrollWidth - 2);
    });
  }

  /* (13) barre de progression */
  var bar = document.createElement('div'); bar.className = 'pg5s'; bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var r = root.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      setHdr();
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { checkWraps(); onScroll(); });
  window.addEventListener('load', checkWraps);
  setHdr(); checkWraps(); onScroll();
})();
